import { Captions, CaptionsOff } from "@aircall/react-icons";
import type { ComponentType } from "react";
import type { IconColorClass } from "@/playground/components/DevHome/table/components/IconWithTooltip/IconWithTooltip.decl";

export type TranscriptType =
  | "AVAILABLE"
  | "LOW_CONFIDENCE"
  | "NO_SPEECH_DETECTED"
  | "BAD_ACOUSTICS";

// Icon rendered by IconWithTooltip as `<Icon className width height />`: a
// local prop shape (matches IconWithTooltip's own) so we don't depend on
// tractor's IconProps.
type CellIconComponent =
  | string
  | ComponentType<{
      className?: string;
      width?: number | string;
      height?: number | string;
    }>;

export type TranscriptMapProps = {
  [key in TranscriptType]: {
    color: IconColorClass;
    title: string;
    description?: string;
    icon: CellIconComponent;
  };
};

export const transcriptMap: TranscriptMapProps = {
  AVAILABLE: {
    icon: Captions,
    color: "text-muted-foreground",
    title: "transcript_available",
  },
  LOW_CONFIDENCE: {
    icon: CaptionsOff,
    color: "text-muted-foreground",
    title: "transcript_unavailable",
    description: "transcript_low_confidence",
  },
  NO_SPEECH_DETECTED: {
    icon: CaptionsOff,
    color: "text-muted-foreground",
    title: "transcript_unavailable",
    description: "transcript_no_speech_detected",
  },
  BAD_ACOUSTICS: {
    icon: CaptionsOff,
    color: "text-muted-foreground",
    title: "transcript_unavailable",
    description: "transcript_bad_acoustics",
  },
};
